module.exports = __webpack_public_path__ + "SourceSansPro-BlackItalic.4ad90ff9116938091367.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-BlackItalic.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-BlackItalic.woff
// module chunks = styles